module.exports = __webpack_public_path__ + "static/media/design-illustration-2.ee1c0c55.svg";